import { render } from "./FosRes.vue?vue&type=template&id=1c3f528d&scoped=true"
import script from "./FosRes.vue?vue&type=script&lang=js"
export * from "./FosRes.vue?vue&type=script&lang=js"

import "./FosRes.vue?vue&type=style&index=0&id=1c3f528d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3f528d"]])

export default __exports__